export default __webpack_public_path__ + "static/media/nodejs-icon.3dc364b8.svg";